import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { ICommonState, commonTypes } from './types';
import commonActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
export const INITIAL_STATE: ICommonState = {
  showNavbar: true,
  showSecondBurger: false,
  showSidebar: false,
  collapseSidebar: false,
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: ICommonState, payload: UnsafeReturnType<T>): ICommonState;
}

const setSidebar: IActionHandler<typeof commonActions['setSidebar']> = (state, { payload }) => ({
  ...state,
  showSidebar: payload,
});

const setCollapseSidebar: IActionHandler<typeof commonActions['setCollapseSidebar']> = (state, { payload }) => ({
  ...state,
  collapseSidebar: payload,
});

const setShowSecondBurger: IActionHandler<typeof commonActions['setCollapseSidebar']> = (state, { payload }) => ({
  ...state,
  showSecondBurger: payload,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [commonTypes.SET_SIDEBAR]: setSidebar,
  [commonTypes.SET_COLLAPSE_SIDEBAR]: setCollapseSidebar,
  [commonTypes.SET_SHOW_SECOND_BURGER]: setShowSecondBurger,
};

const commonReducer = createReducer<ICommonState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export default commonReducer;
